import { render, staticRenderFns } from "./coupon-unit.vue?vue&type=template&id=01abb5bd&lang=pug&"
import script from "./coupon-unit.vue?vue&type=script&lang=js&"
export * from "./coupon-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports